export function extractDomain(url: string): string {
    const parts = url.split('//');
    const domain = parts[1].split('/')[0];
    if (domain.indexOf(':')) {
      return domain.split(':')[0];
    }
    return domain;
  }
